import uniq from 'lodash/uniq'

const APPLY_FOR_VALID_VALUES = ['delivery', 'pickup', 'order_at_table']

const AppliedForValueSanitizer = (values: string[]) =>
  uniq(values).filter((value: string) => APPLY_FOR_VALID_VALUES.includes(value))

export { AppliedForValueSanitizer }
